import React, { useState, useEffect, useLayoutEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { funcionesTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService, puedeEditarServicio } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHFuncionGet } from "services/services-mia/programa-salud/personal/RNHFuncionGet";

export default function Funciones() {
  const credentials = useRecoilValue(userCredentials);
  const setRoute = useSetRecoilState(routeInfo);
  const [modalDetails, setModalDetails] = useState({ isOpen: false });
  const [loading, setLoading] = useState(false);
  const [funciones, setFunciones] = useState([]);
  const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
  const { service } = useService();

  const getFunciones = async () => {
    setFunciones([]);
    setRowSelected({ status: false, row: {} });
    setLoading(true);
    const { data: result } = await RNHFuncionGet(credentials);
    const newRows = result[0]?.rnhFuncionId ? result?.map((data) => {
      return {
        id: data?.rnhFuncionId,
        cod: data?.rnhFuncionCod,
        nombre: data?.rnhFuncionNombre,
        // OJO CON EL NOMBRE DEL CAMPO: `rnhFuncionAgrupamientoId` termina en "Id"
        // pero su contenido es el NOMBRE del agrupamiento ("Agrupamiento de Cocina"),
        // no un numero. Para la columna viene justo; para el <select> del modal de
        // modificar no sirve, y hay que resolverlo contra el catalogo.
        agrupamiento: data?.rnhFuncionAgrupamientoId ?? "",
        version: data?.rnhFuncionVersion
      };
    }) : []
    setFunciones(newRows);
    setLoading(false);
  }
  const closeModal = () => {
    setModalDetails({ isOpen: false });
  };
  const handleClick = ({ procede, title }) => {
    setModalDetails({ procede, title, isOpen: true });
  };

  useEffect(() => {
    getFunciones()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useLayoutEffect(() => {
    setRoute({
      wordKey: `Funciones - Programa Salud RN`
    })
  }, [service.servicioNombre, setRoute])

  return (
    <main className={styles.main}>
      <Modal
        size={modalDetails.procede === ACTIONS.DELETE ? 'sm' : 'md'}
        open={modalDetails.isOpen}
        title={modalDetails.title}
        onClose={closeModal}
      >
        {modalDetails.procede === ACTIONS.UPDATE && (
          <UpdateModal
            row={rowSelected.row}
            updateList={getFunciones}
            closeModal={closeModal}
          />
        )}
        {modalDetails.procede === ACTIONS.DELETE && (
          <DeleteModal
            row={rowSelected.row}
            servicio={service}
            updateList={getFunciones}
            closeModal={closeModal}
            setterRowSelected={setRowSelected}
          />
        )}
        {modalDetails.procede === ACTIONS.INSERT && (
          <InsertModal
            servicio={service}
            updateList={getFunciones}
            closeModal={closeModal}
          />
        )}
      </Modal>
      <div className={styles["filters-actions-right"]}>
        <Buttons>
          <HeaderButton
            text={"Actualizar"}
            onClick={() => { getFunciones() }}
            disabled={rowSelected.row.id || false}
          >
            <Cached />
          </HeaderButton>
          <HeaderButton
            text={"Nueva Función"}
            handleClick={handleClick}
            data={{
              title: "Nueva Función",
              procede: ACTIONS.INSERT
            }}
            disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
          >
            <Add />
          </HeaderButton>
          <HeaderButton
            text={"Modificar Función"}
            handleClick={handleClick}
            data={{
              title: "Modificar Función",
              procede: ACTIONS.UPDATE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <EditOutlined />
          </HeaderButton>
          <HeaderButton
            text={"Eliminar Función"}
            handleClick={handleClick}
            data={{
              title: "Eliminar Función",
              procede: ACTIONS.DELETE
            }}
            disabled={!puedeEditarServicio(service) || (!rowSelected.row.id)}
          >
            <DeleteOutlineRoundedIcon />
          </HeaderButton>
        </Buttons>
      </div>
      <div className={styles.container}>
        <XGrid
          rows={funciones}
          titles={titles}
          loading={loading}
          secondarySelected={rowSelected}
          setSecondarySelected={setRowSelected}
        />
      </div>
    </main>
  );
}